import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import PhraseLabel from 'ui/PhraseLabel';
import { devices } from 'styles/devices';
import { colors } from 'styles/colors';

const Section = ({ headline, id, children, className }) => (
   <Wrapper className={className} id={id}>
      <PhraseLabel>{headline}</PhraseLabel>
      <Content>
         <Responsive>{children}</Responsive>
      </Content>
   </Wrapper>
);

const Responsive = styled.div`
   display: block;
   overflow-x: auto;
`;

const Wrapper = styled.section`
   display: block;
   padding: 30px 0 0;

   ${devices.mobile} {
      padding: 35px 0 0;
   }

   ${devices.desktopHD} {
      padding: 50px 0 0;
   }
`;

const Content = styled.div`
   table {
      width: 100%;
      max-width: 100%;
      margin-bottom: 1rem;
      font-size: 14px;
      color: ${colors.neutral70};
      border-collapse: collapse;
      table-layout: fixed;
   }

   thead {
      background: ${colors.primary};
      color: ${colors.white};

      > tr {
         background: ${colors.primary};
         color: ${colors.white};
      }
   }

   th {
      padding: 0.75rem;

      &:not(:first-of-type) {
         border-left: 1px solid ${colors.white};
      }
   }

   tbody {
      tr {
         &:nth-of-type(even) {
            background-color: ${colors.neutral10};
         }
      }
   }

   td {
      padding: 0.75rem;

      &:not(:first-of-type) {
         border-left: 1px solid ${colors.neutral20};
      }
   }
`;

Section.propTypes = {
   id: PropTypes.string.isRequired,
   headline: PropTypes.string.isRequired,
   children: PropTypes.node.isRequired,
   className: PropTypes.string
};

Section.defaultProps = {
   className: ''
};

export default Section;
